import httpClient from '@/apis/base/httpclient';
import DashboardApi from './_dashboardApi';

class DashboardUsingSavingAPI extends DashboardApi {
  constructor() {
    super();
  }
  controllerName = 'Dashboards';

  /**
   * Hàm kiểm tra xem báo cáo đã được lập hay chưa
   * @returns
   * pqkhanh 23.06.2023
   */
  async getChartData(param) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataChart',
      data: param,
    };

    let res = await httpClient.postAsync(request);
    if(res.Income != 0 || res.Expense != 0 || res.ExpenseWelfare != 0) {
      return [res.Income, res.Expense, res.ExpenseWelfare];
    }
    return [];
  }
}

export default new DashboardUsingSavingAPI();
